import { StyleSheet, Platform } from 'react-native'

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  container: {
    paddingTop: 35,
    paddingHorizontal: 16,
    flex: 1
  },
  title: (theme) => ({
    color: theme.colors.textColor,
    fontSize: Platform.OS === 'ios' ? 25 : 24,
    fontFamily: Fonts.type.VodafoneLt,
    marginBottom: 30,
  }),
  addLocationContainer: theme => ({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderColor: theme.colors.borderColorThree,
    borderWidth: 1,
    padding: 15,
    borderRadius: 8,
    borderStyle: 'dashed',
  }),
  text: theme => ({
    textAlign: 'center',
    marginVertical: 20,
    fontSize: Fonts.size.regular,
    color: theme.colors.textColorFive
  }),
  addIcon: {
    transform: [{ rotate: '45deg' }],
  },
  locationText: {
    ...Fonts.type.bold,
    fontSize: Fonts.size.regular,
    marginLeft: 15
  },
  buttonContainer: insets => ({
    flex: 1,
    justifyContent: 'flex-end',
    paddingBottom: insets.bottom
  }),
  editButton: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  editText: theme => ({
    fontSize: Fonts.size.h6,
    color: theme.colors.seeBillColor,
    marginRight: 7
  }),
  addressText: {
    fontSize: Fonts.size.h5,
    fontFamily: Fonts.type.VodafoneLt,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  addressContainer: theme => ({
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.colors.cardBackgroundColor,
    paddingVertical: 15,
    marginTop: 20,
    borderRadius: 6,
    paddingHorizontal: 16,
    padding: 20,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 6,
    shadowOpacity: 1,
    elevation: 2,
  }),
  yourAddress: {
    ...Fonts.type.bold,
    fontSize: Fonts.size.h5,
    marginLeft: 10,
    flex: 1
  }
})
